import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function BusinessActivityCodeInfoContent() {
  return (
    <>
      <InfoPanelTitle>What is the business activity code?</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          Choose the option that most closely describes your day-to-day
          revenue-producing activity. These codes come from the IRS NAICS list
          and help identify the type of work your business performs.
        </p>

        <p>If your exact activity isn&apos;t listed, pick the closest match.</p>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'IRS NAICS list',
              url: 'https://www.irs.gov/instructions/i1040sc#en_US_2024_publink100039367',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
